import { plainToClass } from "class-transformer";
import { DateUpdatedSection } from "../../../../shared/components/date-updated-section/date-updated-section.view";
import { RemoveElementFromArray } from "../../../../shared/scripts/array-functions";
import { RenderNullableNumber } from "../../../../shared/scripts/table-functions";
import { ExecutiveSummaryEntry } from "./executive-summary.entities";



export class ExecutiveSummaryPage {

    dataTables: any[] = [];

    openParentHashes: string[] = [];

    constructor(DataJson: any, LastUpdatedJson: any) {

        $(() => {

            new DateUpdatedSection(LastUpdatedJson);

            let data: ExecutiveSummaryEntry[] = plainToClass(ExecutiveSummaryEntry, <ExecutiveSummaryEntry[]>DataJson);
            data.forEach((element: ExecutiveSummaryEntry) => element.initialize());

            let screenedRow: ExecutiveSummaryEntry = data.find(i => i.Label == "Screened (Post Consent)");
            let randomizedRow: ExecutiveSummaryEntry = data.find(i => i.Label == "Randomized");

            data.forEach((element: ExecutiveSummaryEntry) => {
                if (element.Type == 0 || element.Type == 2 || element.Type == 4) {
                    if (element.Group == "Participant-Screen") element.createDisplayValues(screenedRow);
                    else if (element.Group == "Participant-Random") element.createDisplayValues(randomizedRow);
                }
            });

            //console.log(data);

            ////console.log(allRows);

            this.initializeSection(data.filter((entry: ExecutiveSummaryEntry) => entry.Group == "Site"), "executive-summary-sites-table", "Sites");
            this.initializeSection(data.filter((entry: ExecutiveSummaryEntry) => entry.Group == "Participant-Screen" || entry.Group == "Participant-Random"), "executive-summary-participants-table", "Participants");
            //this.initializeSection(data.filter((entry: ExecutiveSummaryEntry) => entry.Group == "AdverseEffects"), "executive-summary-adverse-effects-table");

            //this.initializeTable(allRows);
            this.setRowVisibility();
            this.resetColumnVisibility();

            // Need to bind header clicks off body+selector rather than the table
            // because the fixedHeaders extension creates new tables when scrolling
            $('body').on('click', 'thead th', (event) => {

                this.dataTables.forEach((dt) => {
                    if (dt.column($(event.currentTarget)).index()) {
                        this.toggleColumns(dt.column($(event.currentTarget)).index(), dt);
                    }
                });
            });
        });
    }

    private initializeSection(data: ExecutiveSummaryEntry[], tableId: string, tableTitle: string): void {

        //console.log(tableTitle, data);

        let parentRows: ExecutiveSummaryEntry[] = data.filter((element: ExecutiveSummaryEntry) => (element.Type != 2) && (element.Type != 5) && (element.Type != 6));
        parentRows.sort((a: ExecutiveSummaryEntry, b: ExecutiveSummaryEntry) => a.OrderBy - b.OrderBy);

        let alphabeticalChildrenRows: ExecutiveSummaryEntry[] = data.filter((entry: ExecutiveSummaryEntry) => entry.Type == 2 || entry.Type == 5); //need to sort child rows
        let sortedChildrenRows: ExecutiveSummaryEntry[] = data.filter((entry: ExecutiveSummaryEntry) => entry.Type == 6); //need to sort child rows
        alphabeticalChildrenRows.sort((a: ExecutiveSummaryEntry, b: ExecutiveSummaryEntry) => {
            // special sorting for reason child rows (Other and Unknown at the end)
            if (a.Type === 5) {
                if (a.Label.startsWith('Unknown')) return 1;
                if (b.Label.startsWith('Unknown')) return -1;
                if (a.Label.startsWith('Other')) return 1;
                if (b.Label.startsWith('Other')) return -1;
                if (a.Label.startsWith('Unspecified reason')) return 1;
                if (b.Label.startsWith('Unspecified reason')) return -1;
                if (a.Label.startsWith('>')) return 1;
                if (b.Label.startsWith('>')) return -1;
            }

            return a.Label.localeCompare(b.Label);
        });
        sortedChildrenRows.sort((a: ExecutiveSummaryEntry, b: ExecutiveSummaryEntry) => a.OrderBy - b.OrderBy);

        let childrenRows: ExecutiveSummaryEntry[] = [...alphabeticalChildrenRows, ...sortedChildrenRows];

        let allRows: ExecutiveSummaryEntry[] = [];
        for (let i = 0; i < parentRows.length; ++i) {

            parentRows[i].HasChildren = (parentRows[i].Type == 1) || (parentRows[i].Type == 4);
            parentRows[i].ParentHash = "AlwaysShow";
            allRows.push(parentRows[i]);

            if ((parentRows[i].Type == 1) || (parentRows[i].Type == 4)) {
                let children: ExecutiveSummaryEntry[] = childrenRows.filter((child: ExecutiveSummaryEntry) => child.ParentId == parentRows[i].Id);
                //console.log(children);
                for (let j = 0; j < children.length; ++j) {
                    children[j].ParentHash = "ChildOf" + parentRows[i].Id;
                    children[j].HasChildren = false;
                    children[j].IsLastChild = (j == (children.length - 1));
                    allRows.push(children[j]);

                    if (!this.openParentHashes.includes(children[j].ParentHash)) { this.openParentHashes.push(children[j].ParentHash); }
                }
            }
        }

        this.initializeTable(allRows, tableId, tableTitle);
    }

    private initializeTable(data: ExecutiveSummaryEntry[], tableId: string, tableTitle: string): void {

        let dataTable: any = $('#' + tableId).DataTable({
            "dom": '<"top-controls"B0>>rtip',
            autoWidth: true,
            info: false,
            paging: false,
            search: false,
            scrollX: false,
            //scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            ordering: false,
            fixedHeader: true,
            columns: [
                { className: 'details-control', orderable: false, data: null, defaultContent: '', width: '5px' },
                { data: "Label", title: `<h5 class="">${tableTitle}</h5>`, className: "text-left font-size12", width: '400px' },
                { data: "DisplayValues.0", title: 'VITAL', className: "text-center font-size12 nowrap protocol-column", width: '100px', render: RenderNullableNumber  },
                { data: "DisplayValues.1", title: "Autonomic<br/>Dysfunction", className: "text-center font-size12 nowrap trial-column vital-trial", width: '100px', render: RenderNullableNumber },
                { data: "DisplayValues.2", title: "Cognitive<br/>Dysfunction", className: "text-center font-size12 nowrap trial-column vital-trial", width: '100px', render: RenderNullableNumber },
                { data: "DisplayValues.3", title: "Exercise<br/>Intolerance", className: "text-center font-size12 nowrap trial-column vital-trial", width: '100px', render: RenderNullableNumber },
                { data: "DisplayValues.4", title: "NEURO", className: "text-center font-size12 nowrap", width: '100px', render: RenderNullableNumber },
                { data: "DisplayValues.5", title: "tDCS & BrainHQ", className: "text-center font-size12 nowrap trial-column neuro-trial", width: '100px', render: RenderNullableNumber },
                { data: "DisplayValues.6", title: "AUTONOMIC", className: "text-center font-size12 nowrap protocol-column", width: '100px', render: RenderNullableNumber  },
                { data: "DisplayValues.7", title: "IVIG", className: "text-center font-size12 nowrap trial-column autonomic-trial", width: '100px', render: RenderNullableNumber },
                { data: "DisplayValues.8", title: "Ivabradine", className: "text-center font-size12 nowrap trial-column autonomic-trial", width: '100px', render: RenderNullableNumber },
                { data: "DisplayValues.9", title: "SLEEP", className: "text-center font-size12 nowrap protocol-column", width: '100px', render: RenderNullableNumber },
                { data: "DisplayValues.10", title: "Modafinil/Solriamfetol", className: "text-center font-size12 nowrap trial-column sleep-trial", width: '100px', render: RenderNullableNumber  },
                { data: "DisplayValues.11", title: "Melatonin/Light", className: "text-center font-size12 nowrap trial-column sleep-trial", width: '100px', render: RenderNullableNumber },
                { data: "DisplayValues.12", title: "ENERGIZE", className: "text-center font-size12 nowrap protocol-column", width: '100px', render: RenderNullableNumber },
                { data: "DisplayValues.13", title: "Cardiopulmonary Rehab", className: "text-center font-size12 nowrap trial-column energize-trial", width: '100px', render: RenderNullableNumber },
                { data: "DisplayValues.14", title: "Structured Pacing", className: "text-center font-size12 nowrap trial-column energize-trial", width: '100px', render: RenderNullableNumber },
                { data: "DisplayValues.15", title: "TOTAL <sup>1</sup>", className: "text-center font-size12 nowrap", width: '100px', render: RenderNullableNumber },
                { data: "OrderBy", title: "", visible: false },
                { data: "ParentHash", title: "", visible: false, searchable: true },
            ],
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                    //exportOptions: {
                    //    columns: [1, 2, 3, 4]
                    //}
                }
            ],
            order: [[5, 'asc']],
            data: data,
            rowCallback: (row, data: any, index) => {
                //hide expand for rows without children
                if (!data.HasChildren) {
                    $('td:eq(0)', row).removeClass('details-control');

                    if (data.Type == 2) {
                        $(row).addClass('child-row');

                        if (data.IsLastChild) {
                            $(row).addClass('last');
                        }
                    }

                    if (data.Type == 5 || data.Type == 6) {
                        $(row).addClass('reason-child-row');

                        if (data.IsLastChild) {
                            $(row).addClass('last');
                        }
                    }
                }
                else {
                    $(row).addClass('selectable');
                    if (data.Type == 4) {
                        $(row).addClass('reason-row');
                    }
                }

                //add indent classes
                let cssIndent: string = "indent-" + data.Indent;
                $('td:eq(1)', row).addClass(cssIndent);

                if (data.Type == 3) {
                    $('td:eq(1)', row).addClass('font-italic font-bold');
                }
            }
        });

        dataTable.on('click', 'tbody tr', (event) => {

            let selectedEntry: ExecutiveSummaryEntry = dataTable.row($(event.currentTarget)).data();
            let tr: any = $(event.currentTarget).closest('tr');
            // console.log(selectedEntry);

            if (selectedEntry.HasChildren) {
                let parentHash: string = "ChildOf" + selectedEntry.Id;

                if (this.openParentHashes.includes(parentHash)) {
                    RemoveElementFromArray(this.openParentHashes, parentHash);
                    tr.addClass('opened');
                }
                else {
                    this.openParentHashes.push(parentHash);
                    tr.removeClass('opened');
                }
                this.setRowVisibility();
            }
        });

        this.dataTables.push(dataTable);
    }

    private setRowVisibility(): any {
        let filterString: string = "";

        if (this.openParentHashes.length == 0) { filterString = "ShowEverything"; }
        else {
            this.openParentHashes.forEach((parentHash: string) => {
                if (filterString.length > 0) filterString += "|";
                filterString += parentHash;
            });
        }

        // console.log("filter string = " + filterString);
        filterString = "^((?!" + filterString + ").)*$";

        this.dataTables.forEach((dt: any) => { dt.columns(19).search(filterString, true, false).draw(); });
    }

    private resetColumnVisibility(clearAll=false) {

        this.dataTables.forEach((dt) => {
            // Associated Columns (Appendix/Trial, Symptom Cluster, etc.)
            [3,4,5,7,9,10,12,13,15,16].forEach((i) => dt.column(i).visible(false));
            // Protocols and Total
            [2,6,8,11,14,17].forEach((i) => {
                (clearAll) ? dt.column(i).visible(false) : dt.column(i).visible(true);
                $(dt.column(i).header()).removeClass('protocol-open');
            });

        });
    }

    private toggleColumns(idx: any, dataTable: any) {
        if ([2, 8, 11, 14].indexOf(idx) > -1) {
            const v = dataTable.column(idx + 1).visible();
            // this.resetColumnVisibility(!v); // Drill-down to appendices
            this.resetColumnVisibility(false); // Expand appendices inline
            if (!v) {
                this.dataTables.forEach((dt) => {
                    dt.column(idx).visible(true);
                    $(dt.column(idx).header()).addClass('protocol-open');
                    dt.column(idx + 1).visible(true);
                    if ([2, 8, 11, 14].indexOf(idx) > -1) dt.column(idx + 2).visible(true);
                    if ([2].indexOf(idx) > -1) dt.column(idx + 3).visible(true);
                });
            }
        } else if (idx > 2) {
            this.resetColumnVisibility(false);
        }
    }

}